/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Base,
    BaseFromJSON,
    BaseFromJSONTyped,
    BaseToJSON,
    OWLogCategory,
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    TimeStamps,
    TimeStampsFromJSON,
    TimeStampsFromJSONTyped,
    TimeStampsToJSON,
} from './';

/**
 * Represents a raw Overwolf event.
 * @export
 * @interface GameEventData
 */
export interface GameEventData {
    /**
     * The ID of the user who triggered the event.
     * @type {string}
     * @memberof GameEventData
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEventData
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof GameEventData
     */
    gameTitle: string;
    /**
     * Raw event info from Overwolf.
     * @type {object}
     * @memberof GameEventData
     */
    eventInfo: object;
    /**
     * 
     * @type {string}
     * @memberof GameEventData
     */
    eventName?: string;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof GameEventData
     */
    category: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof GameEventData
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GameEventData
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GameEventData
     */
    updatedAt: number;
}

export function GameEventDataFromJSON(json: any): GameEventData {
    return GameEventDataFromJSONTyped(json, false);
}

export function GameEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameEventData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'gameId': json['gameId'],
        'gameTitle': json['gameTitle'],
        'eventInfo': json['eventInfo'],
        'eventName': !exists(json, 'eventName') ? undefined : json['eventName'],
        'category': OWLogCategoryFromJSON(json['category']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function GameEventDataToJSON(value?: GameEventData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'gameId': value.gameId,
        'gameTitle': value.gameTitle,
        'eventInfo': value.eventInfo,
        'eventName': value.eventName,
        'category': OWLogCategoryToJSON(value.category),
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}


